import { render, staticRenderFns } from "./IconTabs.vue?vue&type=template&id=8b000ad6&scoped=true"
import script from "./IconTabs.vue?vue&type=script&lang=js"
export * from "./IconTabs.vue?vue&type=script&lang=js"
import style0 from "./IconTabs.vue?vue&type=style&index=0&id=8b000ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b000ad6",
  null
  
)

export default component.exports